import { useQuery, useQueryClient } from '@tanstack/react-query';
import { payersApi } from '../api/payersApi';
import { payerKeys } from '../queryKeys';

export function useIvrMapVersions(payerId: string | null) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: payerKeys.map(payerId ?? ''),
    queryFn: () => payersApi.getPayerMap(payerId as string),
    enabled: !!payerId,
  });

  function invalidate() {
    if (payerId) queryClient.invalidateQueries({ queryKey: payerKeys.map(payerId) });
  }

  return { ...query, bundle: query.data ?? null, invalidate };
}
